/**
 * @module geo/actions/creators
 *
 */

import { ADD_MENU_ITEM } from "../../payload/facade/ADD_MENU_ITEM";
import { actionCreatorsBuilder } from "../helpers/actions.creator.builder";
import { TypeKeyActions } from "../types.key.action";
import {Acknowledged} from '../../payload/response/acknowledged';

export const [
  /**
   * return an action to add an item to FunctionsLauncher menu
   * @since 2.1.0
   */
  addMenuItemCreator,
  /**
   * return an assync action to add an item to FunctionsLauncher menu
   * @since 2.1.0
   */
  addMenuItemAsyncCreator,
  /**
   * return a action builder with a promise to add an item to FunctionsLauncher menu
   * @since 2.1.0
   */
  addMenuItemCreatorP
] = actionCreatorsBuilder<ADD_MENU_ITEM, Acknowledged, Error>(
  TypeKeyActions.ADD_MENU_ITEM
);
